// extracted by mini-css-extract-plugin
export default {"forecatsHeroIcon":"hero_forecatsHeroIcon__jKGDw"};